import { OrderPaymentMethodCode } from "@omni/types/api/cart/bff/shared/enums/orderPaymentMethodCodes.enum";
import { PaymentIssuerCode } from "@omni/types/api/cart/bff/shared/enums/paymentIssuerCode.enum";
import { PaymentMethodCode } from "@omni/types/components/payment/shared/enum/paymentMethodCode.enum";
import { values } from "lodash-es";

import { Config } from "@/utils/config.utils";

/**
 * DO NOT ASSIGN TO TOP LEVEL VARIABLES
 * The values won't be reevaluated when the config changes (eg. between requests in a server context)
 * Module federation only evaluates the module once
 */
export const DamImage = {
    product: {
        everydayLowPrice: () =>
            `${Config.general["dam-path"]}/system/product/everyday-low-price-${Config.getLanguage()}.png`,
        guaranteeNotice: () =>
            `${Config.general["dam-path"]}/system/product/guarantee-notice-${Config.getLanguage()}.png`
    },
    icon: {
        label: {
            "ecoCheques": () =>
                `${Config.general["dam-path"]}/system/icon/label/eco-cheques.gif`,
            "eco": () =>
                `${Config.general["dam-path"]}/system/icon/label/eco.svg`,
            "transport": () =>
                `${Config.general["dam-path"]}/system/icon/label/transport.png`,
            "homeDelivery": () =>
                `${Config.general["dam-path"]}/system/icon/label/home-delivery.png`,
            "webOnly": () =>
                `${Config.general["dam-path"]}/system/icon/label/web-only.png`,
            "fsc": () =>
                `${Config.general["dam-path"]}/system/icon/label/fsc.png`,
            "pefc": () =>
                `${Config.general["dam-path"]}/system/icon/label/pefc.png`,
            "gewasbescherming": () =>
                `${Config.general["dam-path"]}/system/icon/label/gewasbescherming.png`,
            "recupel": () =>
                `${Config.general["dam-path"]}/system/icon/label/recupel.jpg`,
            "bebat": () =>
                `${Config.general["dam-path"]}/system/icon/label/bebat.jpg`
        },
        maps: {
            "marker": () =>
                `${Config.general["dam-path"]}/system/icon/maps/marker.png`,
            "icon": () =>
                `${Config.general["dam-path"]}/system/icon/maps/icon.png`,
            "markerDot": () =>
                `${Config.general["dam-path"]}/system/icon/maps/marker-dot.svg`,
            "markerFav": () =>
                `${Config.general["dam-path"]}/system/icon/maps/marker-fav.png`
        },
        payment: [
            ...values(PaymentMethodCode),
            ...values(OrderPaymentMethodCode),
            ...values(PaymentIssuerCode)
        ].reduce(
            (acc, code) => {
                acc[code] = () =>
                    `${Config.general["dam-path"]}/system/icon/payment/${code.toLowerCase()}.png`;

                return acc;
            },
            {} as Record<
                PaymentMethodCode | OrderPaymentMethodCode | PaymentIssuerCode,
                () => string
            >
        )
    },
    calculator: {
        "bricks": () =>
            `${Config.general["dam-path"]}/system/calculator/baksteen.jpg`,
        "halfBrick": () =>
            `${Config.general["dam-path"]}/system/calculator/muur-halve-steen.jpg`,
        "fullBrick": () =>
            `${Config.general["dam-path"]}/system/calculator/muur-volle-steen.jpg`,
        "corrugatedSheets": () =>
            `${Config.general["dam-path"]}/system/calculator/calculator-corrugated-sheets.png`,
        "epdmLShape": () =>
            `${Config.general["dam-path"]}/system/calculator/calculator-aquaplan-L-vormig-dak-epdm.png`,
        "epdmRectangleShape": () =>
            `${Config.general["dam-path"]}/system/calculator/calculator-aquaplan-rechthoekig-dak-epdm.png`,
        "glassBrick": () =>
            `${Config.general["dam-path"]}/system/calculator/glasdal.jpg`,
        "gravel": () =>
            `${Config.general["dam-path"]}/system/calculator/calculator-gravel.jpg`,
        "tileClassic": () =>
            `${Config.general["dam-path"]}/system/calculator/tegel-klassiek.jpg`,
        "tileDiagonal": () =>
            `${Config.general["dam-path"]}/system/calculator/tegel-overhoeks.jpg`,
        "yTong": () =>
            `${Config.general["dam-path"]}/system/calculator/y-tong.jpg`
    }
} as const;
